import { Toaster, toast } from 'react-hot-toast';
export const notify = ({type = 'success',message = 'Updated', position = 'top-right', reverseOrder = false}) => {
    const options = { position, reverseOrder};
    if (type === 'error')toast.error(message, options); 
    else if (type === 'loading')toast.loading(message, options); 
    else if (type === 'success') toast.success(message, options); 
};
const Notification = () => <Toaster />;
export default Notification;